// Основные страницы сайта: ядро шаблонов, код сайта и библиотеки страницы в одном файле.
import { createRuntime } from '../runtime/index';
import { installAngularCompat } from '../runtime/angular-compat';
import { $ } from '../lib/dollar';
import { installLayout } from '../layout';
import { installMainSlider } from '../main-slider';
import { defineMainApp } from './main-app';
import { startWhenReady } from './start';

// $ нужен скриптам доставок в блоках из БД.
window.$ = $;
const angular = installAngularCompat(createRuntime());
// Запуск и каркас страницы ставятся до кода сайта: ошибка в коде сайта не отменяет запуск,
// меню и слайдер.
startWhenReady(angular);
installLayout(document);
installMainSlider(document);
defineMainApp();
